import { MultiSlideCarousel } from "components/carousel/multiSlide";

export default function Carousel({ slides }) {
  if (!slides.length) return null;

  const slidesMulti = slides.map((item, i) => {
    return {
      widths: [380, 420, 300],
      component: (
        <div
          key={i}
          className="pointer-events-none mx-auto h-100 min-h-[214px] w-[300px] space-y-[10px] object-cover object-center py-3 leading-[130%] md:min-h-[381px] md:w-[420px] lg:w-[380px]"
        >
          <p className="font-bold">{item.title}</p>
          <p className="">{item.bodyText}</p>
        </div>
      ),
    };
  });

  return (
    <div className="max-h-fit w-[calc(var(--vw,_1vw)_*_100)] md:-mx-5 lg:mx-0 lg:w-full">
      <MultiSlideCarousel
        autoplay={true}
        belowSlides="prevNext"
        slides={slidesMulti}
        containerClasses="h-[203px] md:h-[179px] lg:h-[182px]"
        slideClasses="h-100 border-y-2 border-[#C8C8CC]"
        paginationContainerClassesOverride="mt-[20px] flex justify-center"
        responsiveGap={[40, 60, 20]}
        scaleCenter={false}
      />
    </div>
  );
}
